import { MarkerOrderClickData, MarkerPointClickData } from '@common/types/components/map';
import { MapClickData } from '@common/types/components/map/map';

export const isWaypointClickData = (clickData?: MapClickData): clickData is MarkerPointClickData =>
  Boolean(clickData && 'WaypointID' in clickData);

export const isOrderClickData = (clickData?: MapClickData): clickData is MarkerOrderClickData =>
  Boolean(clickData && 'ID' in clickData);
